export const AppFooter = () => {
  return (
    <div className="layout-footer">
      <span className="font-medium ml-2">CÔNG TY TNHH GIẢI PHÁP DOANH NGHIỆP TTC</span>
    </div>
  );
}
